export const TOPIC_ACTIONS = {
  SET_STATE: 'topic/setState',
  GET_TOPICS: 'topic/getTopics',
  GET_FREE_TOPICS: 'topic/getFreeTopics',
  GET_TOPIC_BY_ID: 'topic/getTopicById',
  DESTROY: "topic/destroy"
};
